import React from 'react';
import { Button } from '@mui/material';
import { Cancel as CancelIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface CancelWorkflowButtonProps {
  onCancel?: () => void;
}

export const CancelWorkflowButton: React.FC<CancelWorkflowButtonProps> = ({ onCancel }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onCancel) {
      onCancel();
    } else {
      navigate('/workflows');
    }
  };

  return (
    <Button
      variant="outlined"
      startIcon={<CancelIcon />}
      onClick={handleClick}
      sx={{
        borderColor: '#e2e8f0',
        color: '#64748b',
        '&:hover': {
          borderColor: '#cbd5e1',
          backgroundColor: '#f8fafc',
        },
      }}
    >
      Cancel
    </Button>
  );
};

export default CancelWorkflowButton;
